import React from 'react'
import HeroServiziPage from '../Components/Hero/HeroServiziPage';
import Servizi from '../Components/Servizi/ServiziPage';

const heroData = {
    bgImg: 'images/hero-bg.jpg',
    bgShape: 'shape/hero-shape.png',
    sliderImages: [
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
    ],
    title: "Ginecologia e Benessere Intimo",
    description: "<h4>Salute intima e ginecologica in ogni fase della vita, dalla pubert&agrave; alla menopausa.</h4>"
        + "Visite, ecografie, prevenzione, fertilit&agrave; e trattamenti mirati per il benessere ormonale. Approccio personalizzato e tecniche non invasive per migliorare la qualit&agrave; della vita femminile."
};

const ServiziData = {
    img:"/images/crutches.png",
    content2: '<br><br><br>',
    content1: `
        <h2 className="st-text-block-title">Mi occupo della salute ginecologica delle donne in tutte le fasi della vita, dalla pubert&agrave; alla menopausa, con particolare attenzione alla prevenzione e al trattamento di disturbi intimi.</h2><br>
        <ul>
            <li><b>Visite ginecologiche</b> di controllo e consulenze personalizzate</li>
            <li><b>Pap test e tamponi vaginali</b> per la prevenzione di infezioni e patologie</li>
            <li><b>Ecografie ginecologiche transvaginali</b> per il monitoraggio della salute dell&#39;apparato riproduttivo</li>
            <li>Gestione della menopausa, con <b>trattamenti mirati per il benessere ormonale e intimo</b></li>
            <li>Contraccezione e consulenze per la <b>fertilit&agrave;</b></li>
            <li><b>Trattamenti non invasivi</b> per il ringiovanimento vulvo-vaginale, per migliorare la qualit&agrave; della vita in caso di:
                <ol>
                    <li>Incontinenza urinaria da stress</li>
                    <li>Secchezza e atrofia vaginale</li>
                    <li>Lassit&agrave; dei tessuti</li>
                </ol>
            </li>
        </ul>
    `,
};

const AboutPage = () => {
  return (
    <>
      <HeroServiziPage data={heroData} />
      <Servizi data={ServiziData} />
    </>
  )
}

export default AboutPage
